import "./src/styles/global.css";
import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { injectContentsquareScript } from '@contentsquare/tag-sdk';
import { getLocation } from "./src/util/location";

// Inject Contentsquare script only in production environment
if (typeof window !== 'undefined' && process.env.APP_ENV === 'prod') {
  injectContentsquareScript({
    siteId: "6392616",
    async: true,
    defer: false
  });
}

// 1⃣ UTM ID tracking snippet
export const onInitialClientRender = () => {
  // Skip tracking in non-production environments
  if (process.env.APP_ENV !== 'prod') {
    console.log('UTM tracking skipped in non-production environment');
    return;
  }

  const IDS = [
    'gclid',
    'wbraid',
    'gbraid',
    'fbclid',
    'gad_source',
    'gad_campaignid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
  ];

  const DAYS = 1; // Cookie expiry: 1 day
  const qs = new URLSearchParams(window.location.search);

  // Save each ID to individual cookie
  IDS.forEach(id => {
    const val = qs.get(id);
    if (val) {
      const exp = new Date(Date.now() + DAYS * 864e5).toUTCString(); // 864e5 = 1 day
      document.cookie = `${id}=${val};path=/;expires=${exp};SameSite=Lax`;
    }
  });

  // Save full query string
  const fullQueryString = window.location.search;
  if (fullQueryString) {
    const exp = new Date(Date.now() + DAYS * 864e5).toUTCString(); // 864e5 = 1 day
    document.cookie = `ad_metadata=${encodeURIComponent(fullQueryString)};path=/;expires=${exp};SameSite=Lax`;
  }

  // Initialize Hotjar with user country data
  initHotjarIdentification();
};

// Hotjar user identification with country info
const initHotjarIdentification = async () => {
  try {
    // ContentSquare might not load Hotjar immediately, so we need to check and wait if necessary
    const waitForHotjar = () => {
      if (typeof window === 'undefined') return;

      if (window.hj) {
        getLocation().then(locationData => {
          if (locationData) {
            const userId = null; // Replace with your user identification logic
            window.hj('identify', userId, {
              'country': locationData.country || 'Unknown',
              // Add other custom attributes as needed
            });
          }
        }).catch(err => {
          console.error('Error getting location data for Hotjar:', err);
        });
      } else {
        // If Hotjar isn't loaded yet, try again after a delay
        setTimeout(waitForHotjar, 1000);
      }
    };

    waitForHotjar();
  } catch (error) {
    console.error('Error setting up Hotjar identification:', error);
  }
};

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY}
    >
      {element}
    </GoogleReCaptchaProvider>
  );
};
